'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _onboardFormValidation = require('utils/onboardFormValidation');

var _components = require('components');

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginForm = (_dec = (0, _reduxForm.reduxForm)({
  fields: ['email', 'password', 'confirmPassword'],
  form: 'login',
  validate: _onboardFormValidation.validate
}, function (state) {
  return {
    checkingIfExists: state.auth.checkingIfExists,
    checkedIfExists: state.auth.checkedIfExists,
    checkedIfExistsFor: state.auth.checkedIfExistsFor,
    checkedIfExistStatus: state.auth.checkedIfExistStatus
  };
}, { checkIfExists: _auth.checkIfExists }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(LoginForm, _React$Component);

  function LoginForm() {
    (0, _classCallCheck3.default)(this, LoginForm);
    return (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginForm, [{
    key: 'render',
    value: function render() {
      var styles = require('./LoginForm.scss');
      var _props = this.props,
          submitTitle = _props.submitTitle,
          checkingIfExists = _props.checkingIfExists,
          checkedIfExists = _props.checkedIfExists,
          checkedIfExistsFor = _props.checkedIfExistsFor,
          checkedIfExistStatus = _props.checkedIfExistStatus,
          error = _props.error,
          submitting = _props.submitting,
          handleSubmit = _props.handleSubmit,
          _props$fields = _props.fields,
          email = _props$fields.email,
          password = _props$fields.password,
          confirmPassword = _props$fields.confirmPassword;


      var existStatus = checkedIfExistStatus && checkedIfExists === email.value ? checkedIfExistStatus.code : error && error.code || '';

      var isSubmitDisabled = checkingIfExists === email.value || submitting;

      return _react2.default.createElement(
        'form',
        { className: styles.LoginForm, onSubmit: handleSubmit },
        _react2.default.createElement(
          'div',
          { className: styles['LoginForm__fields'] },
          _react2.default.createElement(_components.TextInput, (0, _extends3.default)({
            autoComplete: 'email',
            type: 'email',
            ref: 'email',
            title: 'Email Address',
            className: styles['LoginForm__input--email'] }, email)),
          _react2.default.createElement(_components.TextInput, (0, _extends3.default)({
            autoComplete: 'password',
            type: 'password',
            ref: 'password',
            title: 'Password',
            className: styles['LoginForm__input--password'] }, password))
        ),
        existStatus == 'AccountPasswordNotSet' && _react2.default.createElement(
          'span',
          { className: styles['LoginForm__emailMessage'] },
          checkedIfExistsFor == 'register' ? _react2.default.createElement(
            'span',
            null,
            'If you\'ve set your password by following the link in the email, please enter it above to login and continue purchase!'
          ) : _react2.default.createElement(
            'span',
            null,
            'Your account was created (most likely from a previous Quixel Suite purchase.) but it doesn\'t have a password set.',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            'Please check your email for further instructions on how to login.'
          )
        ),
        error && error.code == 'IncorrectPassword' && _react2.default.createElement(
          'span',
          { className: styles['LoginForm__emailMessage'] },
          'The password looks incorrect. Can you please check and try again?'
        ),
        error && error.code == 'AccountNotFound' && _react2.default.createElement(
          'span',
          { className: styles['LoginForm__emailMessage'] },
          'We couldn\'t find any Quixel account with that email address.',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          'Please check again or try creating a new account instead!'
        ),
        _react2.default.createElement(
          'footer',
          { className: styles.LoginForm__action },
          _react2.default.createElement(_components.Button, {
            primary: true,
            disabled: isSubmitDisabled,
            label: submitTitle })
        )
      );
    }
  }]);
  return LoginForm;
}(_react2.default.Component), _class2.propTypes = (0, _extends3.default)({}, _reduxForm.propTypes, {
  submitTitle: _react2.default.PropTypes.string
}), _class2.defaultProps = {
  submitTitle: 'Login'
}, _temp)) || _class);
exports.default = LoginForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/LoginForm.jsx
// module id = 2732
// module chunks = 0